import React from 'react';
import PropTypes from 'prop-types';
import { Input, InputAdornment, FormControl, InputLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import isMobile from 'ismobilejs';

const styles = theme => ({
  input: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  selectItem: {
    fontSize: 14,
  },

  margin: {
    margin: '8px',
    marginTop: '16px',
    borderBottom: 0,
    width: isMobile.phone ? 'calc(90%)' : '100px',
  },
});
class DollorsInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cost: props.cost,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      cost: nextProps.cost,
    });
  }

  handleChange(value) {
    // The length of number can not more than 8
    if (value && value.length > 8) {
      return;
    }
    // Number only
    if (isNaN(value)) {
      return;
    }
    this.setState({ cost: value });
  }

  render() {
    const { classes, setShipmentCost, order, readOnly, withLabel, isDetailPage } = this.props;
    const { cost } = this.state;
    return (
      <FormControl className={classes.margin} style={{ width: isDetailPage ? '220px' : '' }}>
        {withLabel && (
          <InputLabel htmlFor="adornment-amount">True Shipping Cost (GST excluded)</InputLabel>
        )}
        <Input
          className={classes.input}
          disabled={!!readOnly || order.shippingStatusLabel === 'cancelled'}
          value={cost === null ? '' : cost}
          onChange={e => this.handleChange(e.target.value)}
          onBlur={e => setShipmentCost(order, e.target.value)}
          startAdornment={<InputAdornment position="start">$</InputAdornment>}
        />
      </FormControl>
    );
  }
}

DollorsInput.propTypes = {
  classes: PropTypes.object.isRequired,
  setShipmentCost: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  cost: PropTypes.number,
  readOnly: PropTypes.boolean,
  withLabel: PropTypes.bool,
  isDetailPage: PropTypes.bool,
};

export default withStyles(styles)(DollorsInput);



// WEBPACK FOOTER //
// ./src/components/orders/DollorsInput.js